__turbopack_context__.v({
  "card": "_3gVh3W_card",
  "cards": "_3gVh3W_cards",
  "control": "_3gVh3W_control",
  "description": "_3gVh3W_description",
  "header": "_3gVh3W_header",
  "headline": "_3gVh3W_headline",
  "headlines": "_3gVh3W_headlines",
  "infoButton": "_3gVh3W_infoButton",
  "subtitle": "_3gVh3W_subtitle",
  "title": "_3gVh3W_title",
});
